export default __webpack_public_path__ + "static/media/bloodpressure_info.dbe0276b.jpg";